module.exports = __webpack_public_path__ + "img/default-doctor-image.1654cd69.svg";